module.exports = __webpack_public_path__ + "img/ka.d3665bf1.svg";